import { render, staticRenderFns } from "./EmergencyMatter.vue?vue&type=template&id=0fa7d4e5&scoped=true"
import script from "./EmergencyMatter.vue?vue&type=script&lang=js"
export * from "./EmergencyMatter.vue?vue&type=script&lang=js"
import style0 from "./EmergencyMatter.vue?vue&type=style&index=0&id=0fa7d4e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7d4e5",
  null
  
)

export default component.exports